/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, {useEffect, useState, useRef} from 'react';
import {observer} from 'mobx-react';
import {useStore} from '../../../../../store/store';
import PageWrapper from '../../../../modules/PageWrapper';
import {formatNumberToCash} from '../../../../functions/formatNumber';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import moment from 'moment';
import PaginationBe from '../../../../shared/PaginationBe';
import AddAccounts from './AddAccounts';
import {CreateAppModal} from '../../../../../_metronic/partials';
import {Button} from '../../../../shared/Buttons';
import {SelectorWithSearch} from '../../../../shared/Selectors';
import InputSearch from '../../../../shared/InputSearch';
import Preloader from '../../../../modules/Preloader';

const AccountsWrapper = () => {
  return (
    <PageWrapper
      breadcrumbs={[
        {title: 'Panely', path: ''},
        {isSeparator: true},
        {title: 'Facebook Аккаунты', path: 'tracker/facebook/accounts', isActive: true},
      ]}
      title={'Facebook Аккаунты'}
      firstTimeConfig='today'
      limitDays={7}
    >
      <Accounts />
    </PageWrapper>
  );
};

const active = [
  // {value: '', label: 'Не выбрано'},
  {value: 1, label: 'Активный'},
  {value: 0, label: 'Не активный'},
];

const Accounts = observer(({isVerify, setPreloader, timeConfig}) => {
  const store = useStore();
  const searchDebounceRef = useRef(null);
  const [localPreloader, setLocalPreloader] = useState(false);

  const [accounts, setAccounts] = useState([]);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(1);
  const [total, setTotal] = useState(0);

  const [bayers, setBayers] = useState([]);
  const [agents, setAgents] = useState([]);
  const [origAgents, setOrigAgents] = useState([]);

  const [filters, setFilters] = useState({});

  const [queryText, setQueryText] = useState('');

  useEffect(() => {
    getFilters();
  }, []);

  useEffect(() => {
    const perPage = Number(localStorage.getItem('tracker/facebook/accounts_perPage')) || limit;
    isVerify && timeConfig.time_config && getData(1, filters, perPage);
    setLimit(perPage);
  }, [isVerify, timeConfig]);

  useEffect(() => {
    const containersXL = document.querySelectorAll('.container-xxl');
    containersXL.forEach((el) => (el.style.maxWidth = '100%'));
    return () => {
      containersXL.forEach((el) => (el.style.maxWidth = ''));
    };
  }, []);

  const getData = async (page = 1, filters = null, per_page) => {
    let filtersQue = '';
    if (filters) {
      Object.entries(filters).forEach((item) => {
        filtersQue += `&${item[0]}=${item[1]}`;
      });
    }

    const [getAccounts] = await Promise.all([
      store.requestGet('Traffics/Facebook/Account/getAccounts', {
        params: `time_config=${timeConfig.time_config}&time_start=${timeConfig.time_start}&time_end=${timeConfig.time_end}&page=${page}&per_page=${per_page}${filtersQue}`,
      }),
    ]);

    setOffset(page);
    setAccounts(getAccounts.rows);
    setTotal(getAccounts.total);
    setPreloader(false);
  };

  const getFilters = async () => {
    const [getBayers, getAgents] = await Promise.all([
      store.requestGet(`Traffics/Facebook/getBayersList`),
      store.requestGet('Traffics/Facebook/Agents/getAgentsList'),
    ]);

    setBayers([
      ...getBayers.map((item) => ({
        label: `#${item.id} ${item?.first_name} ${item?.last_name}`,
        value: item.id,
      })),
    ]);

    setAgents([
      ...getAgents?.map((item) => ({
        label: `#${item.id} ${item?.name}`,
        value: item.id,
      })),
    ]);
    setOrigAgents(getAgents);
  };

  const onSearch = (e) => {
    const query = e.target.value;

    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
    setQueryText(query);
    searchDebounceRef.current = setTimeout(async () => {
      setFilters({});
      setLocalPreloader(true);
      const landings = await store.requestGet('Traffics/Facebook/Account/getAccounts', {
        params: `time_config=${timeConfig.time_config}&time_start=${timeConfig.time_start}&time_end=${timeConfig.time_end}&per_page=${limit}&page=1&q=${query}`,
        preloader: false,
      });
      setTotal(landings?.total);
      setAccounts(landings?.rows);
      setLocalPreloader(false);
    }, 1000);
  };

  const update = async (id) => {
    await store.requestGet('Traffics/Facebook/Account/getAccountStats', {
      params: {...timeConfig, id},
    });
  };

  return (
    <div className='card'>
      <div className='card-header py-7'>
        <div
          className='card-toolbar'
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <div>
            <ButtonAdd getData={() => getData(1, null, limit)} bayers={bayers} agents={agents} />
          </div>
          <div className='d-flex flex-wrap' style={{gap: '20px'}}>
            <SelectorWithSearch
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  height: '42px',
                }),
              }}
              placeholder='Расходы...'
              options={[
                {label: 'С расходами', value: 'with_expenses'},
                {label: 'Без расходов', value: 'without_expenses'},
              ]}
              actions={(e) => {
                if (!e) {
                  const newFilters = {...filters};
                  delete newFilters.expenses;
                  getData(1, newFilters, limit);
                  setFilters(newFilters);
                  return;
                }
                getData(1, {...filters, expenses: e.value}, limit);
                setFilters((prev) => ({...prev, expenses: e.value}));
              }}
              value={
                filters.expenses
                  ? [
                      {label: 'С расходами', value: 'with_expenses'},
                      {label: 'Без расходов', value: 'without_expenses'},
                    ].find((item) => item.value === filters.expenses)
                  : null
              }
              clearable={true}
            />
            <SelectorWithSearch
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  height: '42px',
                }),
              }}
              placeholder='Агенты...'
              options={agents}
              actions={(e) => {
                if (!e) {
                  const newFilters = {...filters};
                  delete newFilters.agent_id;
                  getData(1, newFilters, limit);
                  setFilters(newFilters);
                  return;
                }
                getData(1, {...filters, agent_id: e.value}, limit);
                setFilters((prev) => ({...prev, agent_id: e.value}));
              }}
              value={
                filters.agent_id ? agents.find((item) => item.value === filters.agent_id) : null
              }
              clearable={true}
            />
            {store.roles.includes(6) || store.roles.includes(7) ? (
              <></>
            ) : (
              <SelectorWithSearch
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: '42px',
                  }),
                }}
                placeholder='Байера...'
                options={bayers}
                actions={(e) => {
                  if (!e) {
                    const newFilters = {...filters};
                    delete newFilters.bayer_id;
                    getData(1, newFilters, limit);
                    setFilters(newFilters);
                    return;
                  }
                  getData(1, {...filters, bayer_id: e.value}, limit);
                  setFilters((prev) => ({...prev, bayer_id: e.value}));
                }}
                value={
                  filters.bayer_id ? bayers.find((item) => item.value === filters.bayer_id) : null
                }
                clearable={true}
              />
            )}
            <SelectorWithSearch
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  height: '42px',
                }),
              }}
              placeholder='Статус...'
              options={active}
              actions={(e) => {
                if (!e) {
                  const newFilters = {...filters};
                  delete newFilters.is_active;
                  getData(1, newFilters, limit);
                  setFilters(newFilters);
                  return;
                }
                getData(1, {...filters, is_active: e.value}, limit);
                setFilters((prev) => ({...prev, is_active: e.value}));
              }}
              value={
                filters.is_active !== null && filters.is_active !== undefined
                  ? active.find((item) => item.value === filters.is_active)
                  : null
              }
              clearable={true}
            />
            <div className='text-end ms-0 ms-sm-0 mb-5 mb-sm-5 mb-md-0 position-relative'>
              <i
                className='ki-duotone ki-magnifier fs-3 position-absolute'
                style={{left: '15px', top: '13px'}}
              >
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-13'
                placeholder='Поиск'
                value={queryText}
                onChange={onSearch}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='card-body py-4' style={{position: 'relative'}}>
        {localPreloader && <Preloader />}
        <div className='dataTables_wrapper dt-bootstrap4 no-footer'>
          <div className='table-responsive'>
            <table className='table align-middle table-row-dashed fs-6 gy-5'>
              <thead>
                <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                  <th className='min-w-125px text-start' style={{whiteSpace: 'nowrap'}}>
                    Аккаунт
                  </th>
                  <th className='min-w-125px text-start' style={{whiteSpace: 'nowrap'}}>
                    Байер
                  </th>
                  <th className='min-w-125px text-start' style={{whiteSpace: 'nowrap'}}>
                    Агент
                  </th>
                  <th className='min-w-125px text-center' style={{whiteSpace: 'nowrap'}}>
                    Расходы
                  </th>
                  <th className='min-w-125px text-center' style={{whiteSpace: 'nowrap'}}>
                    Токен
                  </th>
                  <th className='min-w-125px text-center' style={{whiteSpace: 'nowrap'}}>
                    Дата отключения
                  </th>

                  <th className='w-90px text-start'></th>
                </tr>
              </thead>

              <tbody className='text-gray-600 fw-semibold'>
                {accounts?.map((item, i) => {
                  const agentName = origAgents.find(
                    (agent) => agent.id === item?.facebook_agent_id
                  );

                  return (
                    <tr key={item.id}>
                      <td>
                        <div
                          className='d-flex fs-6 text-gray-800'
                          style={{display: 'flex', flexDirection: 'column'}}
                        >
                          <span
                            className='me-2'
                            style={{
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              maxWidth: '350px',
                            }}
                          >
                            {item?.account_name}
                          </span>
                          <span className='me-2 text-gray-400'>#{item?.account_id}</span>
                        </div>
                      </td>
                      <td>
                        <div
                          className='d-flex fs-6 text-gray-800'
                          style={{display: 'flex', flexDirection: 'column'}}
                        >
                          <span className='me-2' style={{whiteSpace: 'nowrap'}}>
                            {item?.bayer_fname} {item?.bayer_lname}
                          </span>
                          <span className='me-2 text-gray-400'>#{item?.bayer_id}</span>
                        </div>
                      </td>
                      <td>
                        <div
                          className='d-flex fs-6 text-gray-800'
                          style={{display: 'flex', flexDirection: 'column'}}
                        >
                          {!!item?.facebook_agent_id ? (
                            <>
                              <span className='me-2' style={{whiteSpace: 'nowrap'}}>
                                {`${agentName?.name}`}
                              </span>
                              <span className='me-2 text-gray-400'>
                                {`#${item?.facebook_agent_id}`}
                              </span>
                            </>
                          ) : (
                            <span>-</span>
                          )}
                        </div>
                      </td>
                      <td className='text-center'>{formatNumberToCash(item?.expenses)}</td>
                      <td className='text-center'>
                        <div
                          className={`badge ${
                            !item.active ? 'badge-light-danger' : 'badge-light-success'
                          }`}
                        >
                          {!item.active ? 'Не активный' : 'Активный'}
                        </div>
                      </td>
                      <td className='text-center'>
                        {!!item?.disdate ? (
                          <div className={`badge badge-danger`}>
                            {moment
                              .tz(Date.parse(item?.disdate), 'Europe/Kyiv')
                              .format('DD/MM/YYYY')}
                          </div>
                        ) : (
                          '-'
                        )}
                      </td>

                      <td className='text-end'>
                        <div
                          style={{display: 'flex', flexWrap: 'nowrap', justifyContent: 'flex-end'}}
                        >
                          <ButtonUpdate
                            getData={() => getData(1, null, limit)}
                            data={item}
                            bayers={bayers}
                            agents={agents}
                          />
                          {store.roles.includes(38) ? (
                            <></>
                          ) : (
                            <OverlayTrigger
                              delay={{hide: 450, show: 300}}
                              placement='top'
                              overlay={(props) => (
                                <Tooltip className='fs-8' {...props}>
                                  Обновление расходов
                                </Tooltip>
                              )}
                            >
                              <span
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                onClick={() => update(item?.id)}
                              >
                                <i className='ki-duotone ki-abstract-33 fs-2'>
                                  <span className='path1'></span>
                                  <span className='path2'></span>
                                </i>
                              </span>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        {/* {total > limit && ( */}
        <PaginationBe
          arrLength={total}
          limit={limit}
          page={offset}
          setPage={setOffset}
          action={(currentPage) => {
            getData(currentPage, filters, limit);
          }}
          perPage={limit}
          changePerPage={(e) => {
            setLimit(e);
            getData(1, filters, e);
            localStorage.setItem('tracker/facebook/accounts_perPage', e);
          }}
        />
        {/* )} */}
      </div>
    </div>
  );
});

export const ButtonAdd = ({getData, bayers, agents}) => {
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [warning, setWarning] = useState(false);
  const [save, setSave] = useState(false);

  return (
    <>
      <Button
        action={() => {
          setShowCreateAppModal(true);
          setSave(false);
        }}
      >
        <>
          <i className='ki-duotone ki-plus fs-2'></i>Добавить
        </>
      </Button>
      <CreateAppModal
        customWidth='mw-550px'
        show={showCreateAppModal}
        handleClose={() => {
          if (save) {
            setShowCreateAppModal(false);
          } else {
            setWarning(true);
          }
        }}
        title={'Добавление аккаунта'}
      >
        <AddAccounts
          setWarning={setWarning}
          warning={warning}
          setSave={setSave}
          save={save}
          show={setShowCreateAppModal}
          getData={getData}
          isUpdate={false}
          bayers={bayers}
          agents={agents}
        />
      </CreateAppModal>
    </>
  );
};

const ButtonUpdate = ({getData, data, bayers, agents}) => {
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [warning, setWarning] = useState(false);
  const [save, setSave] = useState(false);

  return (
    <>
      <span
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        onClick={() => {
          setShowCreateAppModal(true);
          setSave(false);
        }}
      >
        <i className='ki-duotone ki-pencil fs-2'>
          <span className='path1'></span>
          <span className='path2'></span>
        </i>
      </span>

      <CreateAppModal
        customWidth='mw-550px'
        show={showCreateAppModal}
        handleClose={() => {
          if (save) {
            setShowCreateAppModal(false);
          } else {
            setWarning(true);
          }
        }}
        title={'Редактирование аккаунта'}
      >
        <AddAccounts
          setWarning={setWarning}
          warning={warning}
          setSave={setSave}
          save={save}
          show={setShowCreateAppModal}
          getData={getData}
          isUpdate={true}
          data={data}
          bayers={bayers}
          agents={agents}
        />
      </CreateAppModal>
    </>
  );
};

export default AccountsWrapper;
